import { Component, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FnToasterService, FnUtilService } from 'foundation';
@Component({
  selector: 'app-eomailteam-modal',
  templateUrl: './eomailteam-modal.component.html',
  styleUrl: './eomailteam-modal.component.scss'
})
export class MailTeamModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: HwDialogData, private dialogRef: MatDialogRef<MailTeamModalComponent>, private fnutilservice: FnUtilService, private toaster: FnToasterService) {
    if (!this.fnutilservice.isEmptyObject(this.dialogData.eoMailTeam)) {
      this.isEdit = true;
      this.objectHash.primaryKey=this.dialogData.eoMailTeam.primaryKey;
      this.objectHash.id = this.dialogData.eoMailTeam.id;
      this.objectHash.name = this.dialogData.eoMailTeam.name;
    }
  }
  isEdit = false;

  objectHash = {
    primaryKey:'',
    id: '',
    name: ''
  }
    close() {
    this.dialogRef.close();
  }

  add() {
    if (this.fnutilservice.isEmptyObject(this.objectHash.id)) {
      this.toaster.error('name can not be null');
      throw new Error();
    }
    if (this.fnutilservice.isEmptyObject(this.objectHash.name)) {
      this.toaster.error('defaultEscEmailId can not be null');
      throw new Error();
    }
     if (!this.validateEmail(this.objectHash.name)) {
      this.toaster.error('Invalid format in default EmailID');
      throw new Error('Invalid defaultEscEmailID');
    }
    this.dialogRef.close(this.objectHash);
  }

   emailRegex = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$");

  validateEmail(emailString: string): boolean {
    if (!emailString) {
      return false;
    }
    const emailArray = emailString.split(',');
    for (let i = 0; i < emailArray.length; i++) {
      const email = emailArray[i].trim();
      if (!this.emailRegex.test(email)) {
        return false;
      }
    }
    return true;
  }

}
interface HwDialogData {
  eoMailTeam: any;
}
